module.exports = __webpack_public_path__ + "img/null_trash.0015efd4.png";